import React from 'react';
import { Center, Text } from '@chakra-ui/react';

import { TOP_BANNER_HEIGHT } from '../constants';

type BannerProps = {
  readonly text: React.ReactNode;
  readonly onClick?: () => void;
  readonly testId?: string;
};

export function Banner({ text, onClick, testId = 'banner' }: BannerProps) {
  return (
    <Center
      py="4px"
      height={TOP_BANNER_HEIGHT}
      background="primaryBranding.600"
      color="white"
      position="fixed"
      data-testid={testId}
      w="100%"
      top={'env(safe-area-inset-top)'}
      zIndex={50}
      onClick={onClick}
      lineHeight={1}
      textAlign="center"
      cursor={onClick ? 'pointer' : 'default'}
    >
      <Text ml={1} fontSize="15px">
        {text}
      </Text>
    </Center>
  );
}
